exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".event-info[data-v-f4aca1f6]{background-color:#fff;border-top:1px solid #82ba1d;border-left:1px solid #82ba1d;font-size:.8rem}.event-info .info-label[data-v-f4aca1f6]{text-align:center;color:#82ba1d}.event-info .info-label[data-v-f4aca1f6],.event-info .info-value[data-v-f4aca1f6]{padding:.1rem .2rem;border-right:1px solid #82ba1d;border-bottom:1px solid #82ba1d}.questionnaire-subhead[data-v-f4aca1f6]{padding:.1rem 1rem;font-size:1.2rem;border:1px solid #000;background-color:#ffffc1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-f4aca1f6&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/page/subPages/MyPage/Order/Download.vue
// module id = 548
// module chunks = 0